'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect } from 'react';
import { useRouter } from 'next/navigation';
interface ModernHeroProps {
  videoUrl?: string;
  fallbackImageUrl?: string;
  title?: string;
  subtitle?: string;
}
export default function ModernHero(t0) {
  const $ = _c(43);
  const {
    videoUrl,
    fallbackImageUrl: t1,
    title: t2,
    subtitle: t3
  } = t0;
  const fallbackImageUrl = t1 === undefined ? "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?auto=format&fit=crop&w=2000&q=80" : t1;
  const title = t2 === undefined ? "Exceptional Properties" : t2;
  const subtitle = t3 === undefined ? "Discover a curated collection of the world's finest residences" : t3;
  const [isLoaded, setIsLoaded] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const router = useRouter();
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const timer = setTimeout(() => setIsLoaded(true), 100);
      return () => clearTimeout(timer);
    };
    t5 = [];
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  useEffect(t4, t5);
  let t6;
  if ($[2] !== router || $[3] !== searchQuery) {
    t6 = e => {
      e.preventDefault();
      if (searchQuery.trim()) {
        router.push(`/real-estate-for-sale?keyword=${encodeURIComponent(searchQuery.trim())}`);
      } else {
        router.push("/real-estate-for-sale");
      }
    };
    $[2] = router;
    $[3] = searchQuery;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleSearch = t6;
  let t7;
  if ($[5] !== fallbackImageUrl || $[6] !== videoUrl) {
    t7 = videoUrl ? <video autoPlay={true} loop={true} muted={true} playsInline={true} className="w-full h-full object-cover" style={{
      filter: "brightness(0.85) contrast(1.1)"
    }} poster={fallbackImageUrl}><source src={videoUrl} type="video/mp4" /></video> : <div className="w-full h-full bg-cover bg-center" style={{
      backgroundImage: `url(${fallbackImageUrl})`,
      filter: "brightness(0.85) contrast(1.1)"
    }} />;
    $[5] = fallbackImageUrl;
    $[6] = videoUrl;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  let t9;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="absolute inset-0 bg-gradient-to-t from-[var(--modern-black)] via-transparent to-[var(--modern-black)]/40" />;
    t9 = <div className="absolute inset-0 bg-[var(--modern-black)]/20" />;
    $[8] = t8;
    $[9] = t9;
  } else {
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7) {
    t10 = <div className="absolute inset-0">{t7}{t8}{t9}</div>;
    $[10] = t7;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  const t11 = `w-16 h-[1px] bg-[var(--modern-gold)] mb-8 transition-all duration-1000 delay-300 ${isLoaded ? "opacity-100 scale-x-100" : "opacity-0 scale-x-0"}`;
  let t12;
  if ($[12] !== t11) {
    t12 = <div className={t11} />;
    $[12] = t11;
    $[13] = t12;
  } else {
    t12 = $[13];
  }
  const t13 = `modern-hero-title text-white mb-6 max-w-4xl transition-all duration-1000 delay-400 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  let t14;
  if ($[14] !== t13 || $[15] !== title) {
    t14 = <h1 className={t13}>{title}</h1>;
    $[14] = t13;
    $[15] = title;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  const t15 = `text-white/70 text-sm md:text-base font-light tracking-[0.15em] uppercase max-w-xl mb-12 transition-all duration-1000 delay-500 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  let t16;
  if ($[17] !== subtitle || $[18] !== t15) {
    t16 = <p className={t15}>{subtitle}</p>;
    $[17] = subtitle;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = `w-full max-w-xl transition-all duration-1000 delay-600 ${isLoaded ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`;
  let t18;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = e_0 => setSearchQuery(e_0.target.value);
    $[20] = t18;
  } else {
    t18 = $[20];
  }
  let t19;
  if ($[21] !== searchQuery) {
    t19 = <input type="text" value={searchQuery} onChange={t18} placeholder="Search by location, address..." className="flex-1 px-6 py-4 bg-white/10 backdrop-blur-md border border-white/30 border-r-0 text-white text-sm placeholder-white/50 tracking-wider focus:outline-none focus:border-[var(--modern-gold)] focus:bg-white/15 transition-all duration-300" />;
    $[21] = searchQuery;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="hidden sm:inline">Explore</span>;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <button type="submit" className="group flex items-center gap-3 px-8 py-4 bg-[var(--modern-gold)] text-[var(--modern-black)] text-xs uppercase tracking-[0.2em] font-medium hover:bg-[var(--modern-gold-light)] transition-all duration-300">{t20}<svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" /></svg></button>;
    $[24] = t21;
  } else {
    t21 = $[24];
  }
  let t22;
  if ($[25] !== t19) {
    t22 = <div className="flex items-stretch">{t19}{t21}</div>;
    $[25] = t19;
    $[26] = t22;
  } else {
    t22 = $[26];
  }
  let t23;
  if ($[27] !== handleSearch || $[28] !== t17 || $[29] !== t22) {
    t23 = <form onSubmit={handleSearch} className={t17}>{t22}</form>;
    $[27] = handleSearch;
    $[28] = t17;
    $[29] = t22;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  const t24 = `absolute bottom-8 left-1/2 -translate-x-1/2 transition-all duration-1000 delay-700 ${isLoaded ? "opacity-100" : "opacity-0"}`;
  let t25;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="w-[1px] h-12 bg-gradient-to-b from-white/50 to-transparent animate-pulse" />;
    $[31] = t25;
  } else {
    t25 = $[31];
  }
  let t26;
  if ($[32] !== t24) {
    t26 = <div className={t24}>{t25}</div>;
    $[32] = t24;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t12 || $[35] !== t14 || $[36] !== t16 || $[37] !== t23 || $[38] !== t26) {
    t27 = <div className="relative z-10 h-full flex flex-col justify-end items-center text-center px-6 pb-24 md:pb-32">{t12}{t14}{t16}{t23}{t26}</div>;
    $[34] = t12;
    $[35] = t14;
    $[36] = t16;
    $[37] = t23;
    $[38] = t26;
    $[39] = t27;
  } else {
    t27 = $[39];
  }
  let t28;
  if ($[40] !== t10 || $[41] !== t27) {
    t28 = <section className="relative w-full h-screen min-h-[700px] overflow-hidden bg-[var(--modern-black)]">{t10}{t27}</section>;
    $[40] = t10;
    $[41] = t27;
    $[42] = t28;
  } else {
    t28 = $[42];
  }
  return t28;
}